<form #form="ngForm" (ngSubmit)="save(form)">

  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <!--Invoice No-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <input pInputText 
               id="invoiceNo" name="invoiceNo"
               class="p-inputtext-sm"
               required
               [(ngModel)]="invoice.invoiceNo" 
               #invoiceNo="ngModel"
               [class.field-error]="form.submitted && invoiceNo.invalid"/>
        <label for="invoiceNo" class="required-field">Invoice No</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && invoiceNo.invalid">Invoice No is required</small>
    </div>

    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-inputNumber  name="invoiceValue"
                        id="invoiceValue" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #invoiceValue="ngModel"
                        [class.field-error]="form.submitted && invoiceValue.invalid"
                        [(ngModel)]="invoice.invoiceValue"></p-inputNumber>
        <label for="invoiceValue" class="required-field">Invoice Value</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && invoiceValue.invalid">Invoice value is required!</small>
    </div>

    <!--Invoice Date-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="invoiceDate"
                    name="invoiceDate"
                    required
                    #invoiceDate="ngModel"
                    [(ngModel)]="invoice.invoiceDate"
                    [class.field-error]="form.submitted && invoiceDate.invalid"></p-calendar>
        <label for="invoiceDate" class="required-field">Invoice Date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && invoiceDate.invalid">Date is required</small>
    </div>

    <!--Income Month-->
    <div class="p-field p-col-12 p-md-3">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="incomeMonth"
                    name="incomeMonth"
                    required
                    #incomeMonth="ngModel"
                    [(ngModel)]="invoice.incomeMonth"></p-calendar>
        <label for="incomeMonth">Income Month</label>
      </span>
    </div>
  </div> 

  <div class="p-fluid p-formgrid-del p-grid">
      <div class="p-field p-col-12 p-md-5">
        <div class="zoesen-upload-file">
          <label for="invoiceImage">
            <i class="pi pi-fw pi-upload"></i>
            Upload Invoice
          </label>
          <input type="file" class="form-control form-control-sm" 
                id="invoiceImage" name="invoiceImage"
                (change)="onFileSelectionChange($event)"/>
        </div>
        <div *ngIf="invoiceImage">
          <table><tr>
            <td><label><strong>{{fileToUpload.name}}</strong> ({{fileToUpload.fileSize}})</label></td>
            <td><button pButton pRipple type="button" icon="pi pi-times" 
                    class="p-button-rounded p-button-danger"
                    (click)="clearAttachment()"></button></td>
          </tr></table>
        </div>
      </div>

      <div class="p-col-12 p-md-7" *ngIf="fileToUpload.isImage">
        <div [style.background-image]="imageUrl" 
            [style.background-size] = "fileToUpload.previewSize"
            class="zoesen-upload-preview"
            style="width:100%;height:200px;">
        </div>
      </div>
  </div>

  <!-- <div class="p-fluid p-formgrid-del p-grid" *ngIf="invoiceImage">
    <div class="p-col-12 p-md-12">
      <label><strong>{{fileToUpload.name}}</strong> ({{fileToUpload.fileSize}})</label>
    </div>
    {{fileToUpload | json}}
  </div>
 -->
  
  <!-- <div class="modal-header bg-info text-white p-2">
    <h5 class="modal-title">Create Invoice</h5>
    <a (click)="cancel()">
      <i class="far fa-times-circle fa-lg"></i>
    </a>
  </div> -->

  <!-- <div class="modal-body">
    <div class="row">
      <div class="col-md-4">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="invoiceNo">Invoice No:</label>
            <input type="text" class="form-control form-control-sm" id="invoiceNo" name="invocieNo"
                    required
                    #invoiceNo="ngModel"
                    [class.field-error]="form.submitted && invoiceNo.invalid"
                    [(ngModel)]="invoice.invoiceNo" />
            <ngb-tooltip-window role="tooltip" id="ngb-tooltip-0"
                                [hidden]="!form.submitted || invoiceNo.valid"
                                class="show tooltip ng-star-inserted bs-tooltip-bottom zoesen-form-error-message">
              <div class="arrow"></div>
              <div class="tooltip-inner">Invoice No is required</div>
            </ngb-tooltip-window>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="invoiceValue">Invoice Value:</label>
            <input type="text" class="form-control form-control-sm" id="invoiceValue" name="invoiceValue"
                    required
                    #invoiceValue="ngModel"
                    [class.field-error]="form.submitted && invoiceValue.invalid"
                    [(ngModel)]="invoice.invoiceValue" />
            <ngb-tooltip-window role="tooltip" id="ngb-tooltip-0"
                                [hidden]="!form.submitted || invoiceValue.valid"
                                class="show tooltip ng-star-inserted bs-tooltip-bottom zoesen-form-error-message">
              <div class="arrow"></div>
              <div class="tooltip-inner">Invoice Value is required</div>
            </ngb-tooltip-window>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="lastName">Invoice Date:</label>
            <div class="input-group">
              <input class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                     id="invoiceDate" name="invoiceDate"
                     required
                     #invoiceDate="ngModel"
                     [class.field-error]="form.submitted && invoiceDate.invalid"
                     [(ngModel)]="invoice.invoiceDate" ngbDatepicker #invoiceDatePicker="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-primary p-0 pl-2 pr-2" (click)="invoiceDatePicker.toggle()" type="button">
                  <i class="far fa-calendar-alt fa-lg"></i>
                </button>
              </div>
            </div>
            <ngb-tooltip-window role="tooltip" id="ngb-tooltip-0"
                                [hidden]="!form.submitted || invoiceDate.valid"
                                class="show tooltip ng-star-inserted bs-tooltip-bottom zoesen-form-error-message">
              <div class="arrow"></div>
              <div class="tooltip-inner">Invoice Date is required</div>
            </ngb-tooltip-window>
          </div>
        </div>

        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="lastName">Income Month:</label>
            <div class="input-group">
              <input class="form-control form-control-sm" placeholder="dd/mm/yyyy"
                     id="incomeMonth" name="incomeMonth"
                     [(ngModel)]="invoice.incomeMonth" ngbDatepicker #incomeMonthPicker="ngbDatepicker">
              <div class="input-group-append">
                <button class="btn btn-outline-primary p-0 pl-2 pr-2" (click)="incomeMonthPicker.toggle()" type="button">
                  <i class="far fa-calendar-alt fa-lg"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div class="form-row">
          <div class="form-group col-md-12">
            <label for="email">Invoice Attachment:</label>
            <input type="file" class="form-control form-control-sm" id="invoiceImage" name="invoiceImage"
                   (change)="onFileSelectionChange($event)"/>
          </div>
        </div>
        <div class="form-row">
          <div class="col-md-12 bg-light"
            [style.background-image]="imageUrl"
            style="width:480px;height:200px;background-position:center;background-repeat:no-repeat;background-size: 470px 190px">
            Image Preview
          </div>
        </div>
      </div>

    </div>
  </div> -->

  <div class="modal-footer">
    <button pButton pRipple label="Save" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
